export const setActiveConversation = (advertId, profileId) => ({
    type: 'SET_ACTIVE_CONVERSATION',
    advert: advertId,
    conversation: profileId
});


// WEBPACK FOOTER //
// ./src/actions/activeConversation.js